import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0d17d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { slot: "spinner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "loading",
    src: "/static/image/column3_bx_loader.gif"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "no-results" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "no-more" }, null, -1))
const _hoisted_5 = {
  slot: "error",
  class: "infinite-attempt-load"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_infinite_loading = _resolveComponent("infinite-loading")!

  return (_openBlock(), _createElementBlock("ul", null, [
    _renderSlot(_ctx.$slots, "list", {}, () => [
      _hoisted_1
    ], true),
    _createVNode(_component_infinite_loading, {
      ref: "infiniteLoading",
      distance: 200,
      onInfinite: _ctx.infiniteHandler
    }, {
      spinner: _withCtx(() => [
        _hoisted_2
      ]),
      complete: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn-try-infinite",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.infiniteAttemptLoad && _ctx.infiniteAttemptLoad(...args)))
          }, " もっと見る ")
        ])
      ]),
      _: 1
    }, 8, ["onInfinite"])
  ]))
}